import React, { useState } from "react";
import { supabase } from "../supabase/client";
import { useAdminAuth } from "./useAdminAuth";

export default function Login() {
  const [username, setUsername] = useState("");
  const [secretKey, setSecretKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  
  const { login } = useAdminAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const { data, error: dbError } = await supabase
        .from("admins")
        .select("*")
        .eq("username", username)
        .eq("secret_key", secretKey)
        .single();

      if (dbError || !data) {
        setError("Invalid credentials. Please check your username and secret key.");
        setLoading(false);
        return;
      }

      // Success Path
      localStorage.setItem("admin_user", data.username);
      login(); // Updates state in your useAdminAuth hook
      window.location.href = "/";
    } catch (err) {
      setError("An unexpected error occurred. Please try again.");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f9fafb] px-4">
      {/* Background Decor */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-black via-[#f525bd] to-black" />
      
      <div className="max-w-md w-full bg-white rounded-[24px] shadow-[0_20px_50px_rgba(0,0,0,0.05)] border border-gray-100 overflow-hidden">
        <div className="p-8 md:p-10">
          {/* Header */}
          <div className="text-center mb-10">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-black text-white text-2xl mb-4 shadow-lg">
              C&F
            </div>
            <h2 className="text-2xl font-bold text-gray-900 tracking-tight">Admin Access</h2>
            <p className="text-gray-500 text-sm mt-2 font-medium uppercase tracking-widest">Curve & Fit Control</p>
          </div>

          <form onSubmit={handleLogin} className="space-y-6">
            {error && (
              <div className="bg-red-50 text-red-600 text-sm p-4 rounded-xl border border-red-100 animate-pulse">
                {error}
              </div>
            )}

            <div className="space-y-1.5">
              <label className="text-xs font-bold text-gray-700 uppercase ml-1">Username</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter username"
                className="w-full px-5 py-4 rounded-xl bg-gray-50 border border-gray-200 focus:border-[#f525bd] focus:bg-white focus:ring-4 focus:ring-pink-50 transition-all outline-none text-gray-900"
                required
              />
            </div>

            <div className="space-y-1.5">
              <label className="text-xs font-bold text-gray-700 uppercase ml-1">Secret Key</label>
              <input
                type="password"
                value={secretKey}
                onChange={(e) => setSecretKey(e.target.value)}
                placeholder="••••••••"
                className="w-full px-5 py-4 rounded-xl bg-gray-50 border border-gray-200 focus:border-[#f525bd] focus:bg-white focus:ring-4 focus:ring-pink-50 transition-all outline-none text-gray-900"
                required
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-4 bg-black text-white rounded-xl font-bold text-sm uppercase tracking-widest hover:bg-gray-900 active:scale-[0.98] transition-all shadow-xl disabled:bg-gray-400"
            >
              {loading ? "Authenticating..." : "Enter Dashboard"}
            </button>
          </form>
        </div>

        <div className="bg-gray-50 p-6 text-center border-t border-gray-100">
          <p className="text-xs text-gray-400 font-medium">
            &copy; {new Date().getFullYear()} Curve & Fit Premium Apparel
          </p>
        </div>
      </div>
    </div>
  );
}